import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/linkedin-history")({
  beforeLoad: () => {
    throw redirect({ to: "/settings", search: {"tab":"linkedin"}, replace: true });
  },
});
